import React, { useEffect } from 'react'
import './style.scss'
import logoSm from "../../assets/images/logo-in-white.png";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import AgencyDropdownFullWidth from 'Components/Common/AgencyDropdownFullWidth';
import { useLocation, useSearchParams } from 'react-router-dom';
import { fetchAgencyMetadataSuggestionsThunk } from 'slices/auth/thunk';
const OnboardingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const onboardingSteps = useSelector((state: RootState) => state.auth.selectedAgency?.onboarding_steps)
    const dispatch:AppDispatch = useDispatch();
    const location = useLocation();

    const totalOnboardingSteps = Object.keys(onboardingSteps ?? {}).length;
    const completedOnboardingSteps = Object.values(onboardingSteps ?? {}).filter((step) => step.status === 'complete').length;

    useEffect(() => {
        dispatch(fetchAgencyMetadataSuggestionsThunk());
    }, [location])

    return (
        <div className='onboarding-layout'>
            <div className="onboarding-layout__header">
                <img src={logoSm} alt="logo" height={25} />
                <AgencyDropdownFullWidth />
            </div>
            <div className="onboarding-layout__content">
            <div className="onboarding-layout__content__bg"></div>
                <div className='onboarding-layout__progress'>
                    <div className='onboarding-layout__progress__bar' style={{ width: `${(completedOnboardingSteps / totalOnboardingSteps) * 100}%` }}></div>
                </div>
                {children}
            </div>
        </div>
    )
}

export default OnboardingLayout